import React from "react"
import { Link, graphql } from "gatsby"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import BlogTagLinks from "../components/BlogTagLinks"
import Helmet from "react-helmet"
import Layout from "../components/Layout"
import Banner from "../components/Banner"

export default class FeaturedListTemplate extends React.Component {
  render() {
    const title = "Featured Sponsorship Opportunities"
    const image = "../img/banner-featured.jpg"
    const posts = this.props.data.allMarkdownRemark.edges

    const { currentFeaturedListPage, numberOfPages } = this.props.pageContext
    const isFirst = currentFeaturedListPage === 1
    const isLast = currentFeaturedListPage === numberOfPages
    const prevPage =
    currentFeaturedListPage - 1 === 1
        ? "/featured"
        : `/featured/${(currentFeaturedListPage - 1).toString()}`
    const nextPage = `/featured/${(currentFeaturedListPage + 1).toString()}`

    return (
      <Layout>
        <Helmet>
          <title>{title} | Looking For Sponsor</title>
          <meta
            name="description"
            content="Featured sponsorship opportunities"
          />
        </Helmet>

        <Banner image={image} title={title} />

        <section className="section">
          <div className="container">
            <div className="columns is-multiline">
              {posts &&
                posts.map(({ node: post }) => (
                  <div className="column is-6" key={post.id}>
                    <div className="card">
                      <header className="card-header">
                        <Link
                          className="card-header-title has-text-primary"
                          to={post.fields.slug}
                        >
                          {post.frontmatter.title}
                        </Link>
                        <div className="card-header-icon">
                          <Link
                            className="button is-link is-small is-rounded"
                            to={post.fields.slug}
                          >
                            Info
                          </Link>
                        </div>
                      </header>

                      <div className="card-content">
                        <div className="content">
                          <p>{post.excerpt}</p>
                          <p>
                            <em>Posted {post.frontmatter.date}</em>
                          </p>
                        </div>
                      </div>

                      <CustomCardFooter className="card-footer">
                        <BlogTagLinks tags={post.frontmatter.tags} />
                      </CustomCardFooter>
                    </div>
                  </div>
                ))}
            </div>
            <div className="level is-mobile">
              <PaginationLevelItems className="level-item has-text-centered">
                {!isFirst && (
                  <Link to={prevPage} rel="prev" className="button">
                    Previous
                  </Link>
                )}
                <div>Page {currentFeaturedListPage}</div>
                {!isLast && (
                  <Link to={nextPage} rel="next" className="button">
                    Next
                  </Link>
                )}
              </PaginationLevelItems>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

FeaturedListTemplate.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

const CustomCardFooter = styled.footer`
  padding: 5px;
`

const PaginationLevelItems = styled.div`
  div {
    margin: 5px;
  }
`

export const featuredListQuery = graphql`
  query featuredListQuery($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: $limit
      skip: $skip
      filter: { frontmatter: { templateKey: { eq: "featured-post" } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 200)
          id
          fields {
            slug
          }
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
            tags
          }
        }
      }
    }
  }
`
